module.exports = __webpack_public_path__ + "img/24-hours.c5508621.svg";